import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingMfaService } from './services/redirect-mfa.service';
import { TranslateService } from '../../core/translation';
import { Router } from '@angular/router';
import { LoginComponent } from '../login.component';

@Component({
  selector: 'app-redirect-mfa',
  templateUrl: './redirect-mfa.component.html',
  styleUrls: ['./redirect-mfa.component.scss']
})
export class RedirectMfaComponent implements OnInit {

  @ViewChild('login') loginComponent: LoginComponent;

  tokenMFA: string = '';
  transactionId: string = '';

  constructor(private _loadingMfaService: LoadingMfaService,
    public _translate: TranslateService,
    public _router: Router) { }

  ngOnInit(): void {
    const route = this._router.parseUrl(this._router.url);
    this.tokenMFA = route.queryParams['token'];
    this.transactionId = route.queryParams['transactionid'];
    this._loadingMfaService.setLoader(true);
    this._loadingMfaService.getLoginTypeProps('loginMFA');
    this.validateUser();
  }

  async validateUser(): Promise<void> {
    const response = await this._loadingMfaService.validateUser(this.tokenMFA, this.transactionId);
    if(response){
      this.loginComponent.enviamos(this._loadingMfaService.response);
    }
  }

}
